module.exports = __webpack_public_path__ + "img/6412cbe3c671b9aee31adf933fec22d.57d20215.png";